export default "__VITE_ASSET__pePNxGQc__"